import { mapGetters } from "vuex";
import * as types from "@/store/types";

const PersonalContact = () =>
  import(
    /* webpackChunkName: "PersonalStatus" */ "@/components/AccountPage/Kyc/PersonalContact/index"
  );

const PersonalInformation = () =>
  import(
    /* webpackChunkName: "PersonalInformation" */ "@/components/AccountPage/Kyc/PersonalInformation/index"
  );
const AutoKyc = () =>
  import(
    /* webpackChunkName: "AutoKyc" */ "@/components/AccountPage/Kyc/AutoKyc/index"
  );

const KycInternationalCard = () =>
  import(
    /* webpackChunkName: "KycTypeSelection" */ "@/components/AccountPage/Kyc/AutoKyc/InternationalCard/index"
  );
const KycVideoGuid = () =>
  import(
    /* webpackChunkName: "KycVideoGuid" */ "@/components/AccountPage/Kyc/AutoKyc/VideoGuid/index"
  );
export default {
  name: "kyc",
  components: {
    PersonalContact,
    PersonalInformation,
    KycInternationalCard,
    KycVideoGuid,
    AutoKyc
  },
  data() {
    return {
      step: 1
    };
  },

  computed: {
    ...mapGetters({
      userVerify: types.userVerifyInfo.getters.GET_USER_VERIFY_INFO
    }),
    handleStep() {
      //TODO: refactor
      switch (this.$route.name) {
        // case "contact":
        //   return 1;
        case "personalInformation":
          return 1;
        case "typeSelection":
          return 2;
        case "internationalCard":
          return 2;
        case "video":
          return 2;
      }
    },
    autoKycStep() {
      return this.$route.params.step;
    }
  }
};
